// TWAP schedule options for chat order row (values in milliseconds)
export const TWAP_SCHEDULE_OPTIONS = [
  { label: 'Every 30sec', value: 30_000 },
  { label: 'Every 1min', value: 60_000 },
  { label: 'Every 2min', value: 120_000 },
  { label: 'Every 5min', value: 300_000 },
  { label: 'Every 10min', value: 600_000 },
  { label: 'Every 15min', value: 900_000 },
  { label: 'Every 30min', value: 1_800_000 },
]

// TWAP duration options for chat order row (values in milliseconds)
export const TWAP_DURATION_OPTIONS = [
  { label: '30min', value: 1_800_000 },
  { label: '1h', value: 3_600_000 },
  { label: '2h', value: 7_200_000 },
  { label: '4h', value: 14_400_000 },
  { label: '4h 30min', value: 16_200_000 },
  { label: '6h', value: 21_600_000 },
  { label: '8h', value: 28_800_000 },
  { label: '12h', value: 43_200_000 },
  { label: '24h', value: 86_400_000 },
]

// Interval quick-button presets for TwapIntervalInput (values in seconds)
export const TWAP_INTERVAL_PRESETS = [
  { label: '1w', seconds: 604800 },
  { label: '1d', seconds: 86400 },
  { label: '6h', seconds: 21600 },
  { label: '1h', seconds: 3600 },
  { label: '10m', seconds: 600 },
  { label: '1m', seconds: 60 },
  { label: '10s', seconds: 10 },
  { label: '1s', seconds: 1 },
] as const
